import DynamicSectionElement from '@/scripts/dynamic-section-element.js'
import { setRecentlyViewed } from '@/scripts/recently-viewed'

class ProductMain extends DynamicSectionElement {
  constructor () {
    super()

    const fixedClass = 'is-sticky-atc'
    const siteHeaderEl = document.querySelector('[data-slot="header"]')
    const siteFooterEl = document.querySelector('site-footer')
    this.headerHeight =  (siteHeaderEl && siteHeaderEl.offsetHeight) || 0
    const galleryEl = this.querySelector('.js-product-main-gallery')
    const productForm = this.querySelector('.js-form-submit')
    const sellingName = this.dataset.sellingName
   
    if (galleryEl && siteHeaderEl) {
      galleryEl.style.top = this.headerHeight + 'px'
    }

    // Replace dynamic product content when changing variant options
    this.addEventListener('change-variant', (event) => {
      const { origin, pathname } = window.location
      const params = new URLSearchParams({
        variant: event.detail.id
      })
      this.loadSectionFromUrl(`${origin}${pathname}?${params}`, { replaceState: true })
    })

    setRecentlyViewed(this.dataset.handle)

    const isInViewport = (elem) => {
      const distance = elem.getBoundingClientRect()
      return distance.bottom <= this.headerHeight
    }

    if (productForm) {
      window.addEventListener('scroll', () => {
        const stoppingPoint = siteFooterEl ? (siteFooterEl.getBoundingClientRect().top - window.innerHeight) : null
        if (isInViewport(productForm) && (stoppingPoint ? stoppingPoint > 0 : true)) {
          this.classList.add(fixedClass)
        } else {
          this.classList.remove(fixedClass)
        }
      }, { passive: true })
    }
  }

  scrollToReviews() {
    const reviewSectionEl = document.querySelector('#product-reviews')
    if (reviewSectionEl) {
      const offsetTop = reviewSectionEl.offsetTop + window.pageYOffset - 200
      window.scrollTo({
        top: offsetTop,
        left: 0,
        behavior: "smooth",
      })
    }
  }
}

customElements.define('product-main', ProductMain)
